import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-column pl-2 pr-2" }
const _hoisted_2 = { class: "mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "" }, "SPRÁVY", -1)
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = { class: "flex justify-content-end" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search mr-2" }, null, -1)
const _hoisted_7 = { class: "overflow-ellipsis" }
const _hoisted_8 = { class: "grid" }
const _hoisted_9 = { class: "col-10" }
const _hoisted_10 = { class: "field grid" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "ignored",
  class: "col-4"
}, "Ignorovať emailovu adresu", -1)
const _hoisted_12 = { class: "col-8" }
const _hoisted_13 = { class: "field grid" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "mark",
  class: "col-4"
}, "Označiť správu značkou", -1)
const _hoisted_15 = { class: "col-8" }
const _hoisted_16 = { class: "field grid" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", {
  for: "order",
  class: "col-4"
}, "Priradiť objednávku", -1)
const _hoisted_18 = { class: "col-8" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "flex justify-content-center align-items-center",
  style: {"width":"1.8rem"}
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: "p-icon p-button-icon"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
      fill: "currentColor"
    })
  ])
], -1)
const _hoisted_21 = { class: "col-2 flex flex-wrap align-items-center justify-content-center" }
const _hoisted_22 = {
  key: 0,
  class: "card",
  style: {"z-index":"10","position":"absolute","top":"245px","left":"239px","min-width":"31rem","transform-origin":"center top","margin-top":"2px"}
}
const _hoisted_23 = { class: "ml-1 mt-1 flex justify-content-start" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search mr-2" }, null, -1)
const _hoisted_25 = { class: "flex flex-column align-items-center gap-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Načítavanie správ z Gmailu..."),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-600 mt-2" }, "Proces môže trvať 2-3 minúty. Prosím počkajte.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_PrimevueCheckbox = _resolveComponent("PrimevueCheckbox")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_PrimevuePanel = _resolveComponent("PrimevuePanel")!
  const _component_DetailMessage = _resolveComponent("DetailMessage")!
  const _component_PrimevueDialog = _resolveComponent("PrimevueDialog")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_PrimevueButton, {
          label: "Stiahnuť správy",
          severity: "success",
          icon: "pi pi-refresh",
          text: "",
          raised: "",
          class: "uppercase",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.fetchGmailMessages(0)))
        }),
        ($data.googleAuthExpired)
          ? (_openBlock(), _createBlock(_component_PrimevueButton, {
              key: 0,
              label: "Autorizovat google účet",
              severity: "warning",
              icon: "pi pi-key",
              text: "",
              raised: "",
              class: "uppercase",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.callGoogleAuth()))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_DataTable, {
      rowClass: $options.rowClass,
      lazy: "",
      paginator: "",
      rows: this.pagination.rows,
      onPage: $options.onPage,
      first: this.pagination.first,
      loading: $data.loading,
      totalRecords: this.pagination.totalRecords,
      dataKey: "id",
      value: this.messages,
      filters: $data.filters,
      "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => (($data.filters) = $event)),
      onFilter: $options.onFilter,
      filterDisplay: "row",
      globalFilterFields: $data.globalFilterFields,
      stripedRows: "",
      "row-hover": "",
      scrollable: "",
      scrollHeight: `${this.vh - 425}px`,
      virtualScrollerOptions: { itemSize: 40 },
      tableStyle: "width: 100%",
      selection: this.selectedMessage,
      "onUpdate:selection": _cache[4] || (_cache[4] = ($event: any) => ((this.selectedMessage) = $event)),
      selectionMode: "single",
      metaKeySelection: false,
      onRowSelect: _cache[5] || (_cache[5] = ($event: any) => (this.selectedMessage.order && this.selectedMessage.order.id > 0 ? $options.openOrderDetail(this.selectedMessage.order.id) : $options.actions(this.selectedMessage)))
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_IconField, { iconPosition: "left" }, {
            default: _withCtx(() => [
              _createVNode(_component_InputIcon, null, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_InputText, {
                modelValue: $data.filters['global'].value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.filters['global'].value) = $event)),
                placeholder: "Vyhľadať",
                onKeydown: _withKeys($options.onFilter, ["enter"])
              }, null, 8, ["modelValue", "onKeydown"])
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "customerName",
          header: "Zákazník",
          filterField: "customerName",
          showFilterMenu: false,
          filterMenuStyle: { width: '8rem' },
          style: {"width":"5%"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.customerName), 1)
          ]),
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              type: "text",
              onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
              class: "p-column-filter",
              placeholder: "Hľadať",
              style: {"min-width":"10rem"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "subject",
          header: "Predmet",
          filterField: "subject",
          showFilterMenu: false,
          filterMenuStyle: { width: '8rem' },
          style: {"width":"15%"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.subject), 1)
          ]),
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              type: "text",
              onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
              class: "p-column-filter",
              placeholder: "Hľadať",
              style: {"min-width":"10rem"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "bodyTxt",
          header: "Správa",
          style: {"width":"40%"},
          class: "overflow-hidden text-overflow-ellipsis"
        }, {
          body: _withCtx((slotProps) => [
            _createElementVNode("div", _hoisted_7, _toDisplayString(slotProps.data.snippet), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "orderNumber",
          header: "Objednávka",
          filterField: "orderNumber",
          showFilterMenu: false,
          filterMenuStyle: { width: '6rem' },
          style: {"width":"12%"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.orderNumber), 1)
          ]),
          filter: _withCtx(({ filterModel, filterCallback }) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
              type: "text",
              onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
              class: "p-column-filter",
              placeholder: "Hľadať",
              style: {"min-width":"6rem"}
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Dátum",
          style: {"width":"20%"}
        }, {
          body: _withCtx((slotProps) => [
            _createTextVNode(_toDisplayString($options.Utils.parseToSlovakDateTime(slotProps.data.createdAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "" }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode(_component_PrimevueButton, {
              type: "button",
              icon: "pi pi-ellipsis-v",
              onClick: ($event: any) => ($options.actions(slotProps.data)),
              text: "",
              size: "small"
            }, null, 8, ["onClick"]), [
              [
                _directive_tooltip,
                { value: 'Akcie so správou' },
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rowClass", "rows", "onPage", "first", "loading", "totalRecords", "value", "filters", "onFilter", "globalFilterFields", "scrollHeight", "selection"]),
    _createVNode(_component_PrimevueDialog, {
      visible: $data.visibleActions,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => (($data.visibleActions) = $event)),
      onHide: _cache[14] || (_cache[14] = ($event: any) => ($options.hideModal())),
      modal: "",
      header: "Správa",
      style: {"width":"50rem","position":"relative"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PrimevuePanel, {
          header: "Akcie so správou",
          class: "mt-2 mb-2 border-solid border-1 surface-border"
        }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitActions && $options.submitActions(...args)), ["prevent"])),
              name: "actionsForm"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_PrimevueCheckbox, {
                        modelValue: this.ignoredEmail,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((this.ignoredEmail) = $event)),
                        inputId: "ignored",
                        name: "ignored",
                        binary: true
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_PrimevueSelect, {
                        id: "mark",
                        modelValue: this.mark,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((this.mark) = $event)),
                        options: this.store.marks,
                        optionLabel: "name",
                        class: "w-full",
                        placeholder: this.mark.name
                      }, null, 8, ["modelValue", "options", "placeholder"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_PrimevueButton, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (this.visibleSelect = !this.visibleSelect)),
                        label: "test",
                        class: "flex justify-content-between w-full min-h-1rem",
                        outlined: ""
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, [
                            (this.order.id > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                  _createElementVNode("span", null, _toDisplayString(this.order.orderCode), 1),
                                  _createTextVNode(" * "),
                                  _createElementVNode("span", null, _toDisplayString(this.order.customer.lastName), 1),
                                  _createTextVNode(" * "),
                                  _createElementVNode("span", null, _toDisplayString(this.order.customer.city), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_20
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createVNode(_component_PrimevueButton, {
                    type: "submit",
                    icon: "pi pi-save",
                    size: "large",
                    severity: "success",
                    "aria-label": "Save",
                    class: "h-3rem"
                  }, null, 512), [
                    [
                      _directive_tooltip,
                      { value: 'Uloženie nastavení' },
                      void 0,
                      { top: true }
                    ]
                  ])
                ])
              ])
            ], 32)
          ]),
          _: 1
        }),
        _createVNode(_component_DetailMessage, {
          message: this.selectMessage,
          internal: false
        }, null, 8, ["message"]),
        (this.visibleSelect)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_IconField, { iconPosition: "left" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InputIcon, null, {
                      default: _withCtx(() => [
                        _hoisted_24
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_InputText, {
                      modelValue: $data.orderFilters['global'].value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.orderFilters['global'].value) = $event)),
                      placeholder: "Vyhľadať",
                      onInput: $options.onOrderFilter,
                      class: "w-20rem"
                    }, null, 8, ["modelValue", "onInput"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_DataTable, {
                lazy: "",
                paginator: "",
                rows: this.selectParams.rows,
                onPage: $options.onOrderPage,
                first: this.selectParams.first,
                loading: this.selectLoading,
                totalRecords: this.selectParams.totalRecords,
                dataKey: "id",
                value: this.orderOptions,
                stripedRows: "",
                "row-hover": "",
                scrollable: "",
                selection: this.selectedOrder,
                "onUpdate:selection": _cache[11] || (_cache[11] = ($event: any) => ((this.selectedOrder) = $event)),
                selectionMode: "single",
                metaKeySelection: false,
                onRowSelect: _cache[12] || (_cache[12] = ($event: any) => ($options.selectOrder(this.selectedOrder))),
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    header: "ID",
                    field: "orderCode",
                    style: {"width":"5%"}
                  }),
                  _createVNode(_component_Column, {
                    header: "Meno",
                    field: "customer.lastName",
                    style: {"width":"50%"}
                  }),
                  _createVNode(_component_Column, {
                    header: "Obec",
                    field: "customer.city",
                    style: {"width":"45%"}
                  })
                ]),
                _: 1
              }, 8, ["rows", "onPage", "first", "loading", "totalRecords", "value", "selection"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_PrimevueDialog, {
      visible: $data.gmailLoading,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => (($data.gmailLoading) = $event)),
      modal: "",
      closable: false,
      draggable: false,
      style: { width: '25rem' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_ProgressSpinner, {
            style: {"width":"50px","height":"50px"},
            strokeWidth: "4"
          }),
          _hoisted_26
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}